<template>
  <Ribbon
    v-if="objectKey"
    id="data-access-ribbon"
  >
    <div class="ribbon_mainRow h-min py-3">
      <h2 class="ribbonName mr-12">
        <Icon
          :type="objectIcon"
          class="ribbonName_icon text-default h-6 w-6"
        />
        <RouterLink
          :to="``"
          class="ribbonName_link truncate text-emphasis text-xl"
          v-html="activeObjectName"
        />
        <ObjectEditDropdown
          base-url="/data-access/objects"
          :object="object"
        />
      </h2>

      <ObjectTypeLinks
        #content
        :object="object"
        active-type="data-access"
      />
    </div>
  </Ribbon>
</template>

<script>
import { mapGetters } from 'vuex';
import Ribbon from '@/components/layout/Ribbon';
import Icon from '@/components/ui/Icon';
import ObjectTypeLinks from '@/components/objects/ObjectTypeLinks';
import ObjectEditDropdown from '@/components/objects/ObjectEditDropdown';
import FieldUtils from '@/components/fields/FieldUtils';

export default {
  name: 'DataAccessRibbon',
  components: {
    Ribbon,
    Icon,
    ObjectTypeLinks,
    ObjectEditDropdown,
  },
  mixins: [
    FieldUtils,
  ],
  computed: {
    ...mapGetters([
      'getObject',
    ]),
    objectKey() {
      return this.$route.params.objectKey;
    },
    object() {
      return this.getObject(this.objectKey);
    },
    activeObjectName() {
      return this.getObject(this.objectKey)?.name ?? '';
    },
    objectIcon() {
      return this.object?.get('integration')?.toLowerCase() ?? 'table-cells';
    },
  },
};
</script>
